module.exports = __webpack_public_path__ + "img/cp11.42e5668c.jpg";